import { ApiRepos } from '../../contracts/ContractVars';

export class ApiError extends Error {
    constructor(message, status, data) {
        super(message);
        this.name = 'ApiError';
        this.status = status;
        this.data = data;
    }
}

const isAbsoluteUrl = (value) => /^https?:\/\//i.test(value);

const buildUrl = (endpoint) => {
    if (!endpoint) {
        return ApiRepos;
    }

    if (isAbsoluteUrl(endpoint)) {
        return endpoint;
    }

    return `${ApiRepos}${endpoint.replace(/^\/+/, '')}`;
};

const parseResponse = async (response) => {
    if (response.status === 204) {
        return null;
    }

    const contentType = response.headers.get('content-type') || '';

    if (contentType.includes('application/json')) {
        return response.json();
    }

    const text = await response.text();
    return text || null;
};

const getErrorMessage = (payload, fallbackMessage) => {
    if (!payload) {
        return fallbackMessage;
    }

    if (typeof payload === 'string') {
        return payload;
    }

    return payload.error || payload.message || fallbackMessage;
};

export const apiClient = {
    async request(endpoint, options = {}) {
        const {
            json,
            headers,
            body,
            credentials = 'include',
            ...rest
        } = options;

        const requestHeaders = { ...headers };
        const requestOptions = {
            credentials,
            ...rest,
            headers: requestHeaders
        };

        if (json !== undefined) {
            requestHeaders['Content-Type'] = 'application/json';
            requestOptions.body = JSON.stringify(json);
        } else if (body !== undefined) {
            requestOptions.body = body;
        }

        const response = await fetch(buildUrl(endpoint), requestOptions);
        const data = await parseResponse(response);

        if (!response.ok) {
            throw new ApiError(
                getErrorMessage(data, `Request failed with status ${response.status}`),
                response.status,
                data
            );
        }

        return data;
    },

    get(endpoint, options = {}) {
        return this.request(endpoint, { method: 'GET', ...options });
    },

    post(endpoint, options = {}) {
        return this.request(endpoint, { method: 'POST', ...options });
    },

    put(endpoint, options = {}) {
        return this.request(endpoint, { method: 'PUT', ...options });
    },

    del(endpoint, options = {}) {
        return this.request(endpoint, { method: 'DELETE', ...options });
    }
};
